import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';
import BrandLogo from './BrandLogo';

const Footer = () => {
  return (
    <footer className="bg-[#EDEEDF] border-t border-black/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <BrandLogo size="lg" tone="light" />
            </div>
            <p className="text-foreground/60 text-sm leading-relaxed max-w-md">
              L'élégance d'un héritage en mouvement. Créations contemporaines inspirées des
              savoir-faire amazighs et des patrimoines méditerranéens.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="p-2 border border-black/20 hover:border-gold hover:text-gold transition-colors" data-testid="social-instagram">
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a href="#" className="p-2 border border-black/20 hover:border-gold hover:text-gold transition-colors" data-testid="social-facebook">
                <Facebook size={18} strokeWidth={1.5} />
              </a>
              <a href="#" className="p-2 border border-black/20 hover:border-gold hover:text-gold transition-colors" data-testid="social-twitter">
                <Twitter size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-widest text-gold mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-sm text-foreground/60 hover:text-gold transition-colors">
                  Boutique
                </Link>
              </li>
              <li>
                <Link to="/shop?is_new=true" className="text-sm text-foreground/60 hover:text-gold transition-colors">
                  Nouveautés
                </Link>
              </li>
              <li>
                <Link to="/shop?is_featured=true" className="text-sm text-foreground/60 hover:text-gold transition-colors">
                  Collections
                </Link>
              </li>
              <li>
                <Link to="/#notre-histoire" className="text-sm text-foreground/60 hover:text-gold transition-colors">
                  Notre histoire
                </Link>
              </li>
              <li>
                <Link to="/#nos-evenements" className="text-sm text-foreground/60 hover:text-gold transition-colors">
                  Nos événements
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-foreground/60 hover:text-gold transition-colors" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-widest text-gold mb-6">Service Client</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-foreground/60">
                  Livraison gratuite dès 150€
                </span>
              </li>
              <li>
                <span className="text-sm text-foreground/60">
                  Retours sous 14 jours
                </span>
              </li>
              <li>
                <span className="text-sm text-foreground/60">
                  Paiement sécurisé
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-foreground/40">
            © {new Date().getFullYear()} MAISON KA. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <span className="text-xs text-foreground/40">
              Paiement sécurisé par Stripe & PayPal
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
